



































import ActionButton from '@/components/ActionButton.vue'
import { RemittanceMessage } from '@/utils/interfaces/remittance.interface'
import Vue from 'vue'
import { mapMutations, mapState } from 'vuex'

export default Vue.extend({
  components: {
    appActionButton: ActionButton,
  },
  props: {
    poster: Function,
  },
  data() {
    return {
      message: '',
    }
  },
  computed: {
    ...mapState(['profile']),
  },
  methods: {
    ...mapMutations('remittanceChat', ['addPending', 'removePending']),
    onEnter(event: KeyboardEvent) {
      if (!this.$vuetify.breakpoint.xs) {
        if (!event.ctrlKey) {
          this.onNew()
          event.preventDefault()
        } else {
          this.message += '\n'
        }
      }
    },
    isEmptyMessage() {
      const lines = this.message.split('\n')
      const words = lines.map(line => line.split(' '))
      console.log(words)
      for (let i = 0; i < words.length; i++) {
        const element = words[i]
        for (let j = 0; j < element.length; j++) {
          const word = element[j]
          if (word !== '') {
            return false
          }
        }
      }
      return true
    },
    async onNew() {
      if (this.isEmptyMessage()) {
        return
      }
      let promise
      if (this.poster) {
        promise = this.poster(this.message)
        this.addPending(promise)
      }
      this.$emit('new-message', {
        message: this.message,
        agency: this.profile.agency_name,
        attached_by: this.profile.username,
        date: new Date().toISOString(),
        promise: promise,
      } as RemittanceMessage)
      this.message = ''
      ;(this.$refs.input as HTMLElement).focus()
      if (promise) {
        try {
          await promise
        } finally {
          this.removePending(promise)
        }
      }
    },
  },
})
